import { PsychiatryNoteSection } from '../components/PsychiatryNoteSection.component';
import { Box } from '@mui/material';
import { CheckboxWithLabel } from '../../../Inputs';

export type IdentityVerificationSectionProps = {
  sessionId: string;
  appointmentId: string;
};

export const IdentityVerificationSection: React.FC<IdentityVerificationSectionProps> = (props) => {
  return (
    <PsychiatryNoteSection title="Identity Verification">
      <Box
        px={3}
        title={`Session ID: ${props.sessionId}`}
      >
        <CheckboxWithLabel
          name="identityVerified"
          label="Have you confirmed the identity of the patient?"
          color="secondary"
        />
      </Box>
    </PsychiatryNoteSection>
  );
};
